import { render, staticRenderFns } from "./ModalEditIngredient.vue?vue&type=template&id=0f009243"
import script from "./ModalEditIngredient.vue?vue&type=script&lang=js"
export * from "./ModalEditIngredient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports